export default "__VITE_ASSET__54mGmKL3__"